import React from 'react';
import DetailsPanel from './DetailsPanel';
import Timeline from './Timeline';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import IssueDisplay from './IssueDisplay';
import DeletedBagMessage from './DeletedBagMessage';
import findDefaultStationCode from '../utils/findDefaultStationCode';
import buildNodesThatAreNotWhatWeExpectForTheTimeline from '../utils/buildNodesThatAreNotWhatWeExpectForTheTimeline';

export default function TimeLineAndDetails(props) {
    const [selectedStationCode, setSelectedStationCode] = useState(
        findDefaultStationCode(props.bagTimeLine)
    );
    const nodesWithIssues = buildNodesThatAreNotWhatWeExpectForTheTimeline(
        props.bagTimeLine
    );
    const { id } = useParams();

    if (nodesWithIssues.length > 0) {
        return (
            <IssueDisplay bagDetailsUrl={props.urlData.bagDetailsUri + id} />
        );
    }

    if (props.isBagDeleted) {
        return <DeletedBagMessage />;
    }

    return (
        <>
            <Timeline
                bagTimeLine={props.bagTimeLine}
                onStationClick={setSelectedStationCode}
                selectedStationCode={selectedStationCode}
            />
            <DetailsPanel
                bagTimeLine={props.bagTimeLine}
                selectedStationCode={selectedStationCode}
                onStationClick={setSelectedStationCode}
                urlData={props.urlData}
            ></DetailsPanel>
        </>
    );
}

TimeLineAndDetails.propTypes = {
    bagTimeLine: PropTypes.instanceOf(Array),
    isBagDeleted: PropTypes.bool.isRequired,
    urlData: PropTypes.instanceOf(Object),
};
